import { useMessage } from './i18n'

export default { useMessage }
